import React, { useState } from "react";
import axios from "axios";
import { Changedpurl, Savedetailsurl } from "./../Utils/urls";
import {
    Box, Typography, Paper, Avatar, TextField, Button,
    CircularProgress, Modal, Fade, Alert, Collapse
} from "@mui/material";
import { FaUser, FaCheckCircle, FaUpload, FaCamera } from 'react-icons/fa';
import { useNavigate, useLocation } from "react-router-dom";
import { getsessionuser, setsessionuser, logoutuser } from './../Utils/sessions';
import SignIn from "../Common/login";

const BRAND = '#900f20';
const BRAND_DARK = '#670600';

const profileLinks = [
    { label: 'Personal Info', path: 'useraccount', match: '/nav/useraccount' },
    { label: 'My Properties', path: 'myproperties', match: '/nav/myproperties' },
    { label: 'My Services', path: 'mybusinesses', match: '/nav/mybusinesses' },
    { label: 'My Blogs', path: 'myblogs', match: '/nav/myblogs' },
    { label: 'Security', path: 'security', match: '/nav/security' },
];

const FieldInput = ({ label, value, onChange, type = 'text', multiline = false }) => (
    <TextField
        fullWidth label={label} value={value || ''} onChange={onChange}
        type={type} multiline={multiline} rows={multiline ? 3 : 1}
        variant="outlined" size="small"
        sx={{
            '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                '&:hover fieldset': { borderColor: BRAND },
                '&.Mui-focused fieldset': { borderColor: BRAND },
            },
            '& .MuiInputLabel-root.Mui-focused': { color: BRAND },
        }}
    />
);

// ── Left navigation ──
const ProfileNav = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Box
            component="nav"
            sx={{
                width: { xs: '100%', md: 240 },
                flexShrink: 0,
                bgcolor: 'white',
                borderRadius: '20px',
                border: '1px solid rgba(0,0,0,0.04)',
                boxShadow: '0 8px 40px rgba(0,0,0,0.06)',
                p: 1.5,
                height: 'fit-content',
                position: { md: 'sticky' },
                top: { md: 24 },
            }}
        >
            {profileLinks.map(link => {
                const active = location.pathname === link.match;
                return (
                    <Box
                        key={link.path}
                        onClick={() => navigate(`/nav/${link.path}`)}
                        sx={{
                            px: 2, py: 1.4, mb: 0.5,
                            borderRadius: '12px',
                            cursor: 'pointer',
                            fontWeight: active ? 700 : 500,
                            fontSize: '0.9rem',
                            color: active ? BRAND : '#4a4a4a',
                            bgcolor: active ? 'rgba(144,15,32,0.08)' : 'transparent',
                            borderLeft: active ? `3px solid ${BRAND}` : '3px solid transparent',
                            transition: 'all 0.15s',
                            '&:hover': {
                                bgcolor: active ? 'rgba(144,15,32,0.08)' : 'rgba(0,0,0,0.03)',
                            },
                        }}
                    >
                        {link.label}
                    </Box>
                );
            })}
        </Box>
    );
};

let color = "white";
let type = "spokes";

const Useraccount = () => {

    const navigate = useNavigate();

    const sessionuser = getsessionuser();
    const [user, setuser] = useState(sessionuser);
    const [showlogin, setshowlogin] = useState(false);

    const [username, setusername] = useState(user?.username);
    const [email, setemail] = useState(user?.email);
    const [phone, setphone] = useState(user?.phone);
    const [bio, setbio] = useState(user?.bio);
    const [gender, setgender] = useState(user?.gender);
    const [age, setage] = useState(user?.age);
    const [course, setcourse] = useState(user?.course);
    const [budget, setbudget] = useState(user?.budget);
    const [hostel, sethostel] = useState(user?.hostel);

    const [profileimage, setprofileimage] = useState('');

    const [progress, setprogress] = useState(false);
    const [loading, setloading] = useState(false);
    const [error, seterror] = useState('');
    const [error2, seterror2] = useState('');
    const [successdiv, setsuccessdiv] = useState(false);
    const [successdiv2, setsuccessdiv2] = useState(false);
    const [changedp, setchangedp] = useState(false);

    const onupload = () => {
        setloading(true)
        seterror2(null)
        const formData = new FormData();
        formData.append("file", profileimage, profileimage.name);

        if (profileimage.name) {
            setloading(true)
            axios.post(Changedpurl + user.id, formData).
                then(response => {
                    setloading(false)
                    if (!response.data.message) {
                        if (response.data.success) {
                            setsuccessdiv2(true)
                            setTimeout(() => {
                                setsuccessdiv2(false)
                                setshowlogin(true)
                            }, 3000);
                        } else {
                            seterror2("there was an internal error contact admin")
                        }
                    } else {
                        setloading(false)
                        seterror2(response.data.message)
                    }
                }).catch(error => {
                    seterror2("Sorry an error occurred,try again later");
                    setloading(false)
                });
        }
    }

    const savedetails = () => {
        setprogress(true)
        seterror(null)
        if (!email || !username || !phone) {
            seterror("fill all fields")
            setprogress(false)
        } else {
            seterror(null)
            axios.post(Savedetailsurl, {
                username: username,
                email: email,
                phone: phone,
                course: course ? course : "none",
                hostel: hostel ? hostel : "none",
                bio: bio ? bio : "none",
                age: age ? age : "none",
                budget: budget ? budget : "none",
                gender: gender ? gender : "none",
                id: user.id
            }).then(response => {
                setprogress(false)
                if (!response.data.error) {
                    setsessionuser(response.data)
                    setuser(response.data)
                    setsuccessdiv(true)
                    setTimeout(() => {
                        setsuccessdiv(false)
                        logoutuser()
                        setshowlogin(true)
                    }, 3000);
                } else {
                    seterror(response.data.message)
                }
            }).catch(error => {
                setprogress(false)
                seterror("Sorry an error occurred,try again later");
            });
        }
    }

    const onsuccesslogin = () => {
        const userobject = sessionStorage?.getItem("user");
        if (userobject) {
            const object = JSON.parse(userobject)
            setuser(object)
        }
        setshowlogin(false)
        setchangedp(false)
    }

    return (
        <Box sx={{ bgcolor: '#f8f9fa', minHeight: '100vh', pb: 10 }}>

            <Modal open={showlogin} onClose={() => setshowlogin(false)}>
                <SignIn onsuccesslogin={onsuccesslogin} />
            </Modal>

            {/* ── Page Header ── */}
            <Box sx={{
                background: `linear-gradient(135deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
                px: { xs: 2, md: 6 }, pt: 4, pb: 8,
            }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: 'white', letterSpacing: '-0.5px', mb: 0.5 }}>
                    My Account
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                    Manage your profile information and preferences
                </Typography>
            </Box>

            {/* ── Nav + Content ── */}
            <Box sx={{
                px: { xs: 2, md: 6 }, mt: -5,
                display: 'flex', flexDirection: { xs: 'column', md: 'row' },
                gap: 3, alignItems: 'flex-start',
            }}>
                <ProfileNav />

                <Paper elevation={0} sx={{
                    borderRadius: '24px', overflow: 'hidden',
                    border: '1px solid rgba(0,0,0,0.04)',
                    boxShadow: '0 8px 40px rgba(0,0,0,0.06)',
                    flex: 1, width: '100%', minWidth: 0,
                }}>

                    {/* ── Avatar Section ── */}
                    <Box sx={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center',
                        pt: 4, pb: 3, borderBottom: '1px solid rgba(0,0,0,0.05)',
                        bgcolor: 'white',
                    }}>
                        <Box sx={{ position: 'relative', mb: 2 }}>
                            <Avatar
                                src={user?.url}
                                sx={{
                                    width: 100, height: 100,
                                    border: `3px solid rgba(144,15,32,0.15)`,
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                                    fontSize: '2.5rem', bgcolor: 'rgba(144,15,32,0.08)', color: BRAND,
                                }}
                            >
                                <FaUser size={36} />
                            </Avatar>
                            <Box
                                onClick={() => setchangedp(true)}
                                sx={{
                                    position: 'absolute', bottom: 2, right: 2,
                                    width: 30, height: 30, borderRadius: '50%',
                                    bgcolor: BRAND, color: 'white',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    cursor: 'pointer', border: '2px solid white',
                                    boxShadow: '0 2px 8px rgba(144,15,32,0.4)',
                                    transition: 'all 0.2s',
                                    '&:hover': { bgcolor: BRAND_DARK, transform: 'scale(1.1)' },
                                }}
                            >
                                <FaCamera size={12} />
                            </Box>
                        </Box>

                        <Typography variant="h6" sx={{ fontWeight: 800, color: '#1a1a1a' }}>{user?.username}</Typography>
                        <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 600 }}>{user?.email}</Typography>

                        <Collapse in={changedp}>
                            <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', justifyContent: 'center' }}>
                                <Box
                                    component="input" type="file" id="avatar-upload"
                                    onChange={e => setprofileimage(e.target.files[0])}
                                    style={{ display: 'none' }}
                                />
                                <Box
                                    component="label" htmlFor="avatar-upload"
                                    sx={{
                                        display: 'inline-flex', alignItems: 'center', gap: 1,
                                        px: 2, py: 1, borderRadius: '10px', cursor: 'pointer',
                                        border: `1px dashed ${BRAND}`, color: BRAND, fontWeight: 600,
                                        fontSize: '0.85rem', transition: 'all 0.2s',
                                        '&:hover': { bgcolor: 'rgba(144,15,32,0.04)' },
                                    }}
                                >
                                    <FaUpload size={13} /> Choose Photo
                                </Box>
                                <Button
                                    onClick={onupload} disabled={loading}
                                    variant="contained" disableElevation size="small"
                                    sx={{
                                        borderRadius: '10px', textTransform: 'none', fontWeight: 700,
                                        background: `linear-gradient(90deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
                                        px: 2.5,
                                    }}
                                >
                                    {loading ? <CircularProgress size={16} sx={{ color: 'white' }} /> : 'Upload'}
                                </Button>
                            </Box>
                        </Collapse>

                        <Collapse in={Boolean(error2)}>
                            <Alert severity="error" sx={{ mt: 1.5, borderRadius: '10px', fontSize: '0.82rem' }}>{error2}</Alert>
                        </Collapse>
                        <Collapse in={successdiv2}>
                            <Alert severity="success" icon={<FaCheckCircle />} sx={{ mt: 1.5, borderRadius: '10px', fontSize: '0.82rem' }}>Photo uploaded successfully!</Alert>
                        </Collapse>
                    </Box>

                    {/* ── Form Body ── */}
                    <Box sx={{ p: { xs: 3, md: 4 }, bgcolor: 'white' }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#1a1a1a', mb: 3 }}>
                            Profile Details
                        </Typography>

                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
                            <Box sx={{ flex: '1 1 200px' }}>
                                <FieldInput label="Username *" value={username} onChange={e => setusername(e.target.value)} />
                            </Box>
                            <Box sx={{ flex: '1 1 200px' }}>
                                <FieldInput label="Email *" value={email} onChange={e => setemail(e.target.value)} />
                            </Box>
                            <Box sx={{ flex: '1 1 200px' }}>
                                <FieldInput label="Phone *" value={phone} type="number" onChange={e => setphone(e.target.value)} />
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
                            <Box sx={{ flex: '1 1 180px' }}>
                                <FieldInput label="Gender" value={gender} onChange={e => setgender(e.target.value)} />
                            </Box>
                            <Box sx={{ flex: '1 1 180px' }}>
                                <FieldInput label="Age" value={age} type="number" onChange={e => setage(e.target.value)} />
                            </Box>
                            <Box sx={{ flex: '1 1 180px' }}>
                                <FieldInput label="Course" value={course} onChange={e => setcourse(e.target.value)} />
                            </Box>
                            <Box sx={{ flex: '1 1 180px' }}>
                                <FieldInput label="Hostel" value={hostel} onChange={e => sethostel(e.target.value)} />
                            </Box>
                            <Box sx={{ flex: '1 1 180px' }}>
                                <FieldInput label="Budget (Ksh)" value={budget} type="number" onChange={e => setbudget(e.target.value)} />
                            </Box>
                        </Box>

                        <Box sx={{ mb: 3 }}>
                            <FieldInput label="Bio" value={bio} onChange={e => setbio(e.target.value)} multiline />
                        </Box>

                        <Collapse in={Boolean(error)}>
                            <Alert severity="error" sx={{ mb: 2, borderRadius: '12px', fontSize: '0.85rem' }}>{error}</Alert>
                        </Collapse>
                        <Collapse in={successdiv}>
                            <Alert severity="success" icon={<FaCheckCircle />} sx={{ mb: 2, borderRadius: '12px', fontSize: '0.85rem' }}>Saved! Logging you back in…</Alert>
                        </Collapse>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                onClick={savedetails} disabled={progress}
                                variant="contained" disableElevation size="large"
                                sx={{
                                    borderRadius: '14px', px: 5, py: 1.4,
                                    textTransform: 'none', fontWeight: 700, fontSize: '1rem',
                                    background: `linear-gradient(90deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
                                    boxShadow: '0 4px 16px rgba(144,15,32,0.25)',
                                    minWidth: 140,
                                    '&:hover': { boxShadow: '0 6px 20px rgba(144,15,32,0.35)', transform: 'translateY(-1px)' },
                                    transition: 'all 0.3s',
                                }}
                            >
                                {progress
                                    ? <CircularProgress size={22} sx={{ color: 'white' }} />
                                    : 'Save Changes'
                                }
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            </Box>
        </Box>
    )
}

export default Useraccount;